import upgradeModal from './upgradeModal';

export default {
    upgradeModal,
};
